import { ApiGroupRequest } from '@ibe/api';

abstract class GroupsUtil {
  public static buildGroupRequest(
    dateFrom: string,
    dateUntil: string,
    text: string,
    adults: number,
    children: number
  ): ApiGroupRequest {
    const request: ApiGroupRequest = {
      dateFrom,
      dateUntil,
      paxContainer: {
        adults: 0,
        children: 0,
        infants: 0,
        childrenAges: [],
        infantsAges: []
      },
      text
    };

    request.paxContainer.adults = adults;
    request.paxContainer.children = children;

    return request;
  }
}

export default GroupsUtil;
